<template>
  <div
    class="main ljb-base-padding ljb-border double-between"
    @click="clickFn">
    <span class="ljb-title title-left">{{ title }}</span>
    <span
      v-show = "rightPart"
      class="title-right ljb-text">{{ rightPart }}</span>
  </div>
</template>

<script>
export default {
  name: 'TextTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    rightPart: {
      type: String,
      default: ''
    }
  },
  methods: {
    clickFn () {
      this.$emit('clickFn')
    }
  }
}
</script>

<style lang="scss" scoped>
  .main{
    background: #fff;
    box-sizing: border-box;
    line-height: 16px;
  }
  .title-left{
  }
  .title-right{
    font-size: 14px;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/components/title/TextTitle.vue